import { render, staticRenderFns } from "./ChartItem.vue?vue&type=template&id=fb016af4&lang=pug&"
import script from "./ChartItem.vue?vue&type=script&lang=js&"
export * from "./ChartItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports